import React, { useContext, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// Components
import Spinner from "../components/Spinners/Spinner";

// Routes
import { PublicRoute } from "./PublicRoute";
import { PrivateRoute } from "./PrivateRoute";
import { AuthContext } from "../context/AuthContext";
import { AuthRouter } from "./AuthRouter";
import { AllRoutes } from "./index";

/**
 * Router principal de la aplicación
 *
 * @returns {React.Component} Router principal
 */
export const AppRouter = () => {
  // Context de autenticación
  const { auth, verifyToken } = useContext(AuthContext);

  // Verificar token
  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  if (auth.checking)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "85vh" }}
      >
        <Spinner />
      </div>
    );

  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas públicas */}
        <Route
          path="/auth/*"
          element={
            <PublicRoute isAuthenticated={auth.logged}>
              <AuthRouter />
            </PublicRoute>
          }
        />

        {/* Rutas privadas */}
        <Route
          path="*"
          element={
            <PrivateRoute isAuthenticated={auth.logged}>
              <AllRoutes />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};
